var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonagens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 676.005,
    height: 355.607,
    viewBox: "0 0 676.005 355.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 61.78,
    cy: 61.78,
    r: 61.78,
    transform: "translate(146.14 88.46)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109",
    transform: "translate(-39.89 -83.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M81.97,264.74a225.446,225.446,0,0,1,42.28,44.75c12.13,16.71,22.37,34.73,31.46,53.25,5.17,10.54,9.97,21.27,14.54,32.08a.652.652,0,0,1-1.2.51,521.981,521.981,0,0,0-27.03-55.65c-10.18-17.83-21.87-34.88-35.66-50.12a207.984,207.984,0,0,0-25.25-23.69C80.39,265.3,81.25,264.17,81.97,264.74Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M84.6,267.85A43.9,43.9,0,0,0,74.35,256.1a23.965,23.965,0,0,0-14.5-5.19c-1.83.02-4.01.57-4.6,2.3-.69,2,1.22,3.9,2.99,5.04C65.79,263.12,74.67,265.4,84.6,267.85Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M89.81,272.68a27.955,27.955,0,0,0-21.19-2.41,9.468,9.468,0,0,0-3.9,1.96,4.175,4.175,0,0,0-1.36,3.97,4.227,4.227,0,0,0,2.88,2.72,11.242,11.242,0,0,0,4.09.31C77.25,278.82,84.1,277.3,89.81,272.68Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M93.31,276.07c-3.51-5.57-6.49-11.93-5.84-18.48a7.867,7.867,0,0,1,1.02-3.43,3.7,3.7,0,0,1,2.96-1.8c1.84,0,3.19,1.7,4.06,3.32C98.5,261.28,99.23,268.04,93.31,276.07Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M101.25,284.03a28.888,28.888,0,0,0-27.31-2.09c-1.86.85-3.9,2.46-3.48,4.46.42,1.98,2.9,2.64,4.92,2.72C83.58,289.46,91.59,286.89,101.25,284.03Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M105.94,288.29a23.22,23.22,0,0,1-3.78-20.04,8.55,8.55,0,0,1,1.59-3.31,3.852,3.852,0,0,1,3.25-1.45c1.98.23,3.17,2.3,3.79,4.19C112.82,273.96,111.91,281.13,105.94,288.29Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M112.21,295.27a34.942,34.942,0,0,0-28.05-2.14c-1.71.61-3.59,1.64-3.87,3.43a3.677,3.677,0,0,0,1.9,3.49,9.46,9.46,0,0,0,4.03,1.09C95.25,302.08,104.51,300.7,112.21,295.27Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M117.48,302.79c-2.1-4.34-3.93-8.89-4.36-13.69s.72-9.91,3.97-13.46a3.925,3.925,0,0,1,3.2-1.6c1.48.2,2.34,1.75,2.85,3.15C126.02,285.11,124.73,294.43,117.48,302.79Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M123.81,309.32a30.709,30.709,0,0,0-27.93-4.37,4.144,4.144,0,0,0-2.72,2.01,2.931,2.931,0,0,0,.98,3.14,7.393,7.393,0,0,0,3.18,1.41A42.413,42.413,0,0,0,123.81,309.32Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M128.13,316.56a22.842,22.842,0,0,1,4.97-23.22,7.85,7.85,0,0,1,4.18-2.55,5.633,5.633,0,0,1,5.53,2.95,8.509,8.509,0,0,1,.49,6.48,17.985,17.985,0,0,1-3.22,5.8C137.58,309.28,134.6,312.14,128.13,316.56Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M134.13,326.31A32.16,32.16,0,0,0,109.3,315.4a8.542,8.542,0,0,0-3.51.67,3.493,3.493,0,0,0-2.06,2.75c-.11,1.76,1.48,3.12,2.97,4.06A32.323,32.323,0,0,0,134.13,326.31Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M138.73,333.07a20.816,20.816,0,0,1,1.82-17.56,10.841,10.841,0,0,1,3.42-3.7,5.675,5.675,0,0,1,4.86-.67,5.945,5.945,0,0,1,3.49,5.26,14.194,14.194,0,0,1-1.47,6.45C148.84,327.59,146.01,332.04,138.73,333.07Z",
    fill: "#63b0ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M87.02,380.31q-9.885-4.26-20.04-7.87c-1.17-.42-2.04,1.33-.86,1.76a331.168,331.168,0,0,1,68.09,33.48q9.135,5.88,17.85,12.37c1,.74,2.3-.71,1.29-1.46A330.718,330.718,0,0,0,87.02,380.31Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M71.65,374.97A27.7,27.7,0,0,0,47.96,363.3c-3.45.17-7.57,1.72-8.03,5.15s3.1,6,6.34,7.25A32.055,32.055,0,0,0,71.65,374.97Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M86,379.5a71.346,71.346,0,0,1-23.47-19.94c-1.27-1.68-2.52-3.91-1.54-5.78a3.923,3.923,0,0,1,3.99-1.77,10.061,10.061,0,0,1,4.2,1.9C78.29,360.1,85.2,369.47,86,379.5Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M101.59,387.55c-4.16-3.65-8.38-7.34-11.48-11.93s-5.02-10.22-4.06-15.67c.3-1.69,1.01-3.5,2.56-4.23,2.41-1.15,5.08.93,6.78,2.98C102.24,366.98,105.94,377.78,101.59,387.55Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M121.86,398.88a30.928,30.928,0,0,1-12.63-24.08,9.556,9.556,0,0,1,.74-4.44,4.09,4.09,0,0,1,3.55-2.43c2.04.05,3.47,2,4.44,3.8C122.43,380,124.43,389.58,121.86,398.88Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M90.01,382.08a36.37,36.37,0,0,0-26.41,3.5c-2.37,1.33-4.85,3.46-4.57,6.16a5.152,5.152,0,0,0,3.95,4.1,12.2,12.2,0,0,0,5.99-.29C76.28,393.78,83.08,389.96,90.01,382.08Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M107.29,390.79a34.146,34.146,0,0,0-29.39,7.6,12.117,12.117,0,0,0-3.95,5.45c-.64,2.18-.06,4.86,1.85,6.08,2.4,1.54,5.56.28,8.05-1.11C91.73,404.41,98.94,398.83,107.29,390.79Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M129.48,402.81c-5.43-.9-10.95-1.63-16.41-1.02s-10.94,2.67-14.74,6.64a10.016,10.016,0,0,0-2.69,4.54,5.282,5.282,0,0,0,1.25,4.95c2.23,2.15,5.89,1.25,8.77.1C114.61,414.43,123.1,409.69,129.48,402.81Z",
    fill: "#63b0ac"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M666.71,213.38a225.438,225.438,0,0,0-27.32,55.17,360.753,360.753,0,0,0-14.48,60.13c-1.86,11.6-3.3,23.25-4.5,34.94a.649.649,0,0,0,1.29.14,522.949,522.949,0,0,1,9.54-61.12c4.51-20.03,10.7-39.75,19.42-58.37a207.818,207.818,0,0,1,17.2-30.05C668.39,213.46,667.23,212.63,666.71,213.38Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M665.11,217.13a43.722,43.722,0,0,1,6.36-14.24,24.028,24.028,0,0,1,12.34-9.21c1.76-.52,4-.63,5.07.85,1.24,1.71-.02,4.08-1.38,5.7C681.71,207.1,673.88,211.88,665.11,217.13Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M661.54,223.28a27.952,27.952,0,0,1,19.55-8.51,9.552,9.552,0,0,1,4.31.73,4.157,4.157,0,0,1,2.46,3.4,4.223,4.223,0,0,1-1.96,3.44,11.073,11.073,0,0,1-3.82,1.49C675.35,225.46,668.35,226.02,661.54,223.28Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M659.19,227.54c1.72-6.35,2.72-13.31.17-19.38a7.873,7.873,0,0,0-1.98-2.98,3.692,3.692,0,0,0-3.36-.85c-1.76.54-2.55,2.56-2.91,4.36C649.89,214.92,651.18,221.59,659.19,227.54Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M653.93,237.48a28.861,28.861,0,0,1,25.5-9.99c2.03.27,4.45,1.21,4.63,3.25.18,2.02-2,3.37-3.91,4.04C672.41,237.5,664.01,237.38,653.93,237.48Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M650.69,242.92a23.2,23.2,0,0,0-2.26-20.27,8.59,8.59,0,0,0-2.49-2.7,3.844,3.844,0,0,0-3.53-.43c-1.83.8-2.36,3.12-2.39,5.12C639.92,231.24,642.89,237.83,650.69,242.92Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M646.74,251.43a34.888,34.888,0,0,1,26.19-10.26c1.81.09,3.91.51,4.7,2.15a3.676,3.676,0,0,1-.79,3.89,9.565,9.565,0,0,1-3.53,2.23C664.95,252.98,655.7,254.37,646.74,251.43Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M643.9,260.17c.74-4.76,1.16-9.66.16-14.37s-3.59-9.26-7.74-11.71a3.9,3.9,0,0,0-3.52-.59c-1.35.63-1.73,2.36-1.8,3.84C630.56,245.77,634.53,254.3,643.9,260.17Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M639.76,268.26a30.677,30.677,0,0,1,25.42-12.35,4.127,4.127,0,0,1,3.19,1.13,2.926,2.926,0,0,1-.02,3.29,7.6,7.6,0,0,1-2.62,2.28A42.461,42.461,0,0,1,639.76,268.26Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M637.76,276.46a22.835,22.835,0,0,0-11.55-20.74,7.778,7.778,0,0,0-4.74-1.21,5.654,5.654,0,0,0-4.43,4.44,8.459,8.459,0,0,0,1.43,6.34,18.237,18.237,0,0,0,4.78,4.61C626.59,272.26,630.28,274.13,637.76,276.46Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M634.87,287.54a32.156,32.156,0,0,1,20.55-17.7,8.468,8.468,0,0,1,3.56-.38,3.518,3.518,0,0,1,2.78,2.03c.62,1.65-.5,3.42-1.66,4.75A32.433,32.433,0,0,1,634.87,287.54Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M632.45,295.34a20.8,20.8,0,0,0-6.88-16.25,10.934,10.934,0,0,0-4.35-2.53,5.689,5.689,0,0,0-4.85.79,5.979,5.979,0,0,0-1.8,6.06,14.1,14.1,0,0,0,3.29,5.74C621.19,293.06,625.19,296.49,632.45,295.34Z",
    fill: "#63b0ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M552.93,269.69q-3.345-10.23-7.36-20.23c-.46-1.15-2.35-.65-1.88.52a330.956,330.956,0,0,1,19.97,73.2q1.635,10.74,2.54,21.57c.11,1.24,2.06,1.25,1.95,0A332,332,0,0,0,552.93,269.69Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M546.76,254.63a27.7,27.7,0,0,0-6.93-25.48c-2.42-2.48-6.3-4.53-9.17-2.61-2.89,1.93-2.45,6.3-1.24,9.55A31.959,31.959,0,0,0,546.76,254.63Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M552.86,268.39a71.236,71.236,0,0,1-.59-30.79c.42-2.07,1.26-4.47,3.31-4.98a3.937,3.937,0,0,1,3.97,1.82,9.995,9.995,0,0,1,1.36,4.4C562.29,249.77,559.85,261.16,552.86,268.39Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M557.14,285.41c-.02-5.53-.04-11.14,1.34-16.5s4.34-10.53,9.06-13.42c1.46-.89,3.29-1.56,4.87-.89,2.45,1.05,2.67,4.42,2.25,7.06C572.99,272.27,567.34,282.2,557.14,285.41Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M562.07,308.1a30.89,30.89,0,0,1,9.69-25.4,9.607,9.607,0,0,1,3.82-2.39,4.085,4.085,0,0,1,4.17,1.06c1.31,1.57.8,3.92.09,5.84C576.6,296.03,570.74,303.87,562.07,308.1Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M553.58,273.1a36.383,36.383,0,0,0-20.1-17.48c-2.56-.9-5.81-1.34-7.65.65a5.156,5.156,0,0,0-.46,5.68,12.2,12.2,0,0,0,4.18,4.3C535.72,270.55,543.09,273.13,553.58,273.1Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M558.49,291.82a34.17,34.17,0,0,0-25.15-17,12.188,12.188,0,0,0-6.7.64c-2.06.96-3.68,3.17-3.33,5.42.43,2.82,3.47,4.35,6.17,5.3C537.98,289.17,546.93,290.88,558.49,291.82Z",
    fill: "#63b0ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M564.16,316.41c-2.92-4.66-6.03-9.28-10.1-12.98s-9.24-6.43-14.73-6.65a9.988,9.988,0,0,0-5.18.99,5.308,5.308,0,0,0-2.88,4.22c-.14,3.1,2.96,5.25,5.73,6.64C545.61,312.95,554.78,316.19,564.16,316.41Z",
    fill: "#63b0ac"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M714.99,419.06H510.49c-3-29.76,1.23-68.77,14.93-89.01a58.343,58.343,0,0,1,7.76-9.38c4.76-4.6,10.42-8,16.93-8.46,13.76-.99,25.3,11.37,39.04,12.36,26.28,1.86,42.57-36.73,68.77-33.95,11.46,1.22,20.75,10.84,24.55,21.73s3.03,22.84,1.23,34.23c-1.03,6.58-2.28,13.84,1.23,19.5,3.7,5.93,11.22,7.89,17.3,11.34a21.78,21.78,0,0,1,7.22,6.8C715.52,393.07,717.14,406.81,714.99,419.06Z",
    fill: "#218282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M709.44,384.21a26.6,26.6,0,0,0-3.11-2.27c-8.92-5.6-21.16-6.76-27.11-15.47-5.73-8.38-2.83-19.62-3.56-29.75a31.838,31.838,0,0,0-7.17-18.52c-4.41-5.1-11.05-8.42-17.78-8.08-11.85.59-20.2,11.31-29.94,18.09a49.982,49.982,0,0,1-36.85,8.12c-9.43-1.66-18.12-5.99-26.96-9.67-7.59-3.18-15.64-5.91-23.8-5.98,4.76-4.6,10.42-8,16.93-8.46,13.76-.99,25.3,11.37,39.04,12.36,26.28,1.86,42.57-36.73,68.77-33.95,11.46,1.22,20.75,10.84,24.55,21.73s3.03,22.84,1.23,34.23c-1.03,6.58-2.28,13.84,1.23,19.5,3.7,5.93,11.22,7.89,17.3,11.34A21.449,21.449,0,0,1,709.44,384.21Z",
    fill: "#3ea396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M683.02,388.14a169.045,169.045,0,0,0-23.15,7.35,97.411,97.411,0,0,1,5.56-18.98c.34-.82-1-1.18-1.33-.37a105.194,105.194,0,0,0-5.84,19.98v.01a197.72,197.72,0,0,0-27.62,13.91,277.483,277.483,0,0,1,30.12-65.52c4.37-6.94,9.09-13.62,13.98-20.19.45-.6-.58-1.41-1.05-.81a260.991,260.991,0,0,0-30.33,49.74q-3.15-10.65-5.5-21.49,7.02-9.495,13.58-19.3c.51-.76-.72-1.47-1.22-.71q-6.165,9.255-12.74,18.23c-1.52-7.24-2.75-14.54-3.64-21.9-.11-.88-1.5-.89-1.39,0q1.425,11.835,3.87,23.54a.538.538,0,0,0,.15.71c1.64,7.71,3.62,15.34,5.99,22.84h0q-5.745,12.5-10.23,25.45-4.11,11.82-7.12,23.97a.705.705,0,0,0,1.36.37q1.62-6.51,3.58-12.94a.8.8,0,0,0,.2-.07,194.042,194.042,0,0,1,25.58-13.23,214.015,214.015,0,0,1,27.55-9.31A.665.665,0,0,0,683.02,388.14Z",
    fill: "#154559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M579.38,355.89Q569,377.205,558.64,398.53q-1.11-5.28-2.14-10.59-2.97-15.36-5.25-30.85-1.32-8.955-2.4-17.93c-.1-.86-1.48-.88-1.37,0q2.79,23.085,7.09,45.94c-4.52-3.34-8.89-6.9-13.06-10.67q-3.21-2.91-6.28-5.97c-1.95-1.95-4.23-3.9-5.43-6.43-.35-.74-1.62-.22-1.33.56.91,2.52,3.18,4.44,5.01,6.3q3.285,3.345,6.75,6.49a173.7,173.7,0,0,0,14.31,11.66.664.664,0,0,0,.42.13q1.29,6.72,2.69,13.41c0,.01-.01.01-.01.02a.672.672,0,0,0,.18.82l.03.15c1.25,5.86,2.43,11.79,3.97,17.59a.716.716,0,0,0,1.38-.38c-1.11-5.14-2.41-10.24-3.53-15.37-.2-.92-.39-1.84-.58-2.76q10.785-22,21.5-44.04C580.97,355.79,579.77,355.09,579.38,355.89Z",
    fill: "#154559"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M375.07,221.59l-.34,1.9-3.59,20.22a119,119,0,0,0-43.19.42c-.97.18-1.94.38-2.9.6a118.952,118.952,0,0,0-16.13,4.67c-.92.32-1.84.67-2.75,1.03a119.94,119.94,0,0,0-16.24,7.8q-1.275.735-2.52,1.5a111.3,111.3,0,0,0-10.3,7.09q-2.22,1.71-4.35,3.54c-.74.63-1.47,1.27-2.2,1.93a117.675,117.675,0,0,0-13.33,14.18l-1.82,2.32a123.738,123.738,0,0,0-10.54,16.47c-.46.87-.92,1.75-1.37,2.63a123.355,123.355,0,0,0-7.61,18.88c-.3.95-.57,1.9-.84,2.85a117.2,117.2,0,0,0-4.02,22.36l-19.57-1.56-2.82-.22a137.751,137.751,0,0,1,3.83-22.99l.76-2.87a145.52,145.52,0,0,1,8.75-23.49l1.3-2.66a146.8,146.8,0,0,1,13.06-21.37c.58-.79,1.17-1.58,1.77-2.35a140.44,140.44,0,0,1,17.81-19.23c.72-.66,1.46-1.29,2.2-1.93,1.71-1.47,3.47-2.9,5.26-4.28a134.154,134.154,0,0,1,12.28-8.44c.83-.53,1.67-1.02,2.51-1.51a141.134,141.134,0,0,1,21.51-10.21l2.76-1a145.9,145.9,0,0,1,21.24-5.78c.97-.18,1.94-.36,2.91-.52A141.7,141.7,0,0,1,375.07,221.59Z",
    fill: "#f08a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M374.73,223.49l-3.59,20.22a119,119,0,0,0-43.19.42c-.97.18-1.94.38-2.9.6a118.952,118.952,0,0,0-16.13,4.67c-.92.32-1.84.67-2.75,1.03a119.94,119.94,0,0,0-16.24,7.8q-1.275.735-2.52,1.5a111.3,111.3,0,0,0-10.3,7.09q-2.22,1.71-4.35,3.54c-.74.63-1.47,1.27-2.2,1.93a117.675,117.675,0,0,0-13.33,14.18l-1.82,2.32a123.738,123.738,0,0,0-10.54,16.47c-.46.87-.92,1.75-1.37,2.63a123.355,123.355,0,0,0-7.61,18.88c-.3.95-.57,1.9-.84,2.85a117.2,117.2,0,0,0-4.02,22.36l-19.57-1.56a135.46,135.46,0,0,1,3.64-20.84l.75-2.87a145.517,145.517,0,0,1,8.75-23.49l1.3-2.66a147.679,147.679,0,0,1,13.06-21.37c.59-.79,1.18-1.58,1.78-2.35a140.289,140.289,0,0,1,17.8-19.22c.73-.66,1.46-1.29,2.21-1.93q2.565-2.205,5.26-4.28a131.936,131.936,0,0,1,12.27-8.43c.84-.53,1.67-1.02,2.52-1.51a141.028,141.028,0,0,1,21.5-10.21l2.76-1a146.029,146.029,0,0,1,21.25-5.78c.97-.18,1.93-.36,2.9-.52A141.329,141.329,0,0,1,374.73,223.49Z",
    fill: "#eb6963"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M289.92,258.23q-1.275.735-2.52,1.5l-11.75-19.12c.83-.53,1.67-1.02,2.51-1.51Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M272.76,270.36l-2.2,1.93-14.64-17.03c.72-.66,1.46-1.29,2.2-1.93Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M257.22,286.46l-1.82,2.32-19.07-11.96c.58-.79,1.17-1.58,1.77-2.35Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M223.28,298.19l21.59,7.06c-.46.87-.92,1.75-1.37,2.63l-21.52-7.04Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M213.22,324.33l22.67,2.43-.85,2.86-22.57-2.42Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M299.68,228.88l6.48,21.54c.91-.37,1.83-.71,2.75-1.03l-6.47-21.52Z",
    fill: "#b03e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M326.59,221.58l1.36,22.55c-.97.18-1.94.38-2.9.6l-1.37-22.62C324.64,221.92,325.62,221.74,326.59,221.58Z",
    fill: "#b03e54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    width: 195.3,
    height: 206.04,
    transform: "translate(328.2 117.43)",
    fill: "#cef2ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7",
    "data-name": "Ret\\xE2ngulo 7",
    width: 181.62,
    height: 206.04,
    transform: "translate(335.03 117.43)",
    fill: "#36bfb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    opacity: 0.549
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M501.43,112.37c4.27,5.96.51,14.83-5.64,18.83s-13.79,4.61-21.03,5.78a121.064,121.064,0,0,0-45.92,17.54c-11.03,7.07-21.01,15.99-33.12,20.99s-27.59,5.06-36.74-4.3c-6.53-6.67-8.42-16.47-10.01-25.67q-2.01-11.58-4.01-23.16c-.44-2.56-.87-5.29.18-7.67,1.81-4.11,6.98-5.27,11.43-5.85C401.95,103,448.17,103.87,501.43,112.37Z",
    fill: "#58d1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M489.61,146.47c-12.7-4.78-26.79,2.21-37.36,10.72s-20.23,19.06-33.21,23.04c-7.51,2.31-17.09,3.29-20.05,10.57-2.2,5.41,1.02,11.85,5.91,15.05s10.99,3.85,16.83,4,11.8-.11,17.39,1.59c13.98,4.24,24.22,20.07,38.75,18.65,12.44-1.22,19.9-15.09,20.49-27.57s-3.34-24.82-3.06-37.31C495.47,158.39,496.71,149.14,489.61,146.47Z",
    fill: "#58d1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M489.32,327.44c5.28-7.5,10.06-15.54,12.34-24.43s1.85-18.77-2.82-26.67c-5.71-9.66-16.51-14.82-26.1-20.64-10.32-6.28-19.82-13.87-30.3-19.87s-22.36-10.44-34.41-9.53-24.15,8.13-28.09,19.55c-3.74,10.84.07,23.7-5.62,33.66-3.99,6.99-11.7,10.78-18.32,15.37s-12.97,11.66-11.76,19.62c.94,6.15,6.35,10.86,12.26,12.82s12.29,1.69,18.51,1.4C409.46,327.11,443.9,325.51,489.32,327.44Z",
    fill: "#58d1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M381.3,193.43c-6.31-4.07-15.93-1.33-19.15,5.45-2.67,5.61-1.13,12.28-2.31,18.39-2.24,11.57-13.85,19.63-15.98,31.23-.86,4.68.61,10.45,5.08,12.09,4.05,1.48,8.56-1.22,11.05-4.74s3.69-7.78,5.85-11.51c4.44-7.68,12.61-12.58,17.32-20.1C389.12,214.7,390.23,199.18,381.3,193.43Z",
    fill: "#58d1c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    opacity: 0.729
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M424.06,263.65c2.81-13.11,3.06-26.64,2-39.96-.61-7.64-1.65-15.24-2.87-22.8-.14-.87-1.54-.84-1.4.05,4.16,25.88,6.13,53.4-3.99,78.22a87.687,87.687,0,0,1-10.45,18.45c-.48.66.65,1.5,1.17.86C416.56,288.55,421.41,276.03,424.06,263.65Z",
    fill: "#054d4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M425.17,230.93a60.978,60.978,0,0,1,53.88-61.61C475.79,198.19,454.17,224.15,425.17,230.93Z",
    fill: "#169c52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M473.8,183.91a83.186,83.186,0,0,0-9.34-.28q4.62-4.29,9.48-8.3c.31-.25-.14-.68-.45-.43q-5.115,4.215-9.95,8.76h-.03a29.5,29.5,0,0,0-1.23-7.97.324.324,0,0,0-.62.19,28.323,28.323,0,0,1,1.2,8.13.3.3,0,0,0,.08.2q-5.55,5.22-10.72,10.81c-.13.14-.25.28-.38.42a24.818,24.818,0,0,0-5.34-9.79c-.3-.33-.74.16-.47.5a28.1,28.1,0,0,1,5.28,9.86.01.01,0,0,0,.01.01q-5.88,6.45-11.2,13.37a35.121,35.121,0,0,0-5.3-7.29c-.29-.3-.73.17-.45.47a33.9,33.9,0,0,1,3.83,4.85c.51.79.95,1.61,1.41,2.43a.437.437,0,0,0,.08.1q-2.955,3.84-5.74,7.79c-.57.81-1.12,1.63-1.67,2.45a1.471,1.471,0,0,1-.1-.13,20.544,20.544,0,0,0-1.61-2.33,12.94,12.94,0,0,0-2.17-2.01c-.32-.24-.75.21-.43.45a12.272,12.272,0,0,1,2.24,2.14,13.4,13.4,0,0,1,.88,1.25,8.336,8.336,0,0,0,.74,1.21c.01.01.02.01.03.02q-3.6,5.355-6.87,10.91c-.21.36.36.67.57.31q3.255-5.52,6.85-10.85a10.445,10.445,0,0,0,2.14.32,13.373,13.373,0,0,1,3.44,1.14c.4.19.73-.41.33-.6a14.576,14.576,0,0,0-3.01-1.07,14.975,14.975,0,0,0-1.63-.27,4.144,4.144,0,0,1-.86-.12q3.57-5.28,7.45-10.33a2.152,2.152,0,0,1,.23.02c.56.05,1.12.1,1.68.16,2.22.22,4.43.46,6.64.74,2.24.28,4.46.69,6.7.95.43.05.6-.58.16-.67-2.6-.5-5.28-.76-7.9-1.08-2.33-.28-4.67-.54-7.02-.75.45-.59.9-1.18,1.37-1.76q4.71-5.97,9.84-11.58a25.773,25.773,0,0,1,12.17,3.7c.37.22.69-.36.32-.58a28.026,28.026,0,0,0-6.18-2.69,30.665,30.665,0,0,0-5.76-1.03q4.455-4.86,9.21-9.44c.67-.64,1.34-1.27,2.01-1.9a82.827,82.827,0,0,1,10.09.28C474.26,184.63,474.24,183.95,473.8,183.91Z",
    fill: "#096647"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M421.87,272.94a61.858,61.858,0,0,1,68.56-47.62C479.99,250.96,453.55,269.23,421.87,272.94Z",
    fill: "#169c52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M485.43,227.31c-4.25,1.94-8.42,4.05-12.52,6.27a15.265,15.265,0,0,0-.16-5.22c-.08-.39-.68-.21-.6.18a14.27,14.27,0,0,1,.06,5.41c-4.52,2.48-8.96,5.12-13.28,7.93-1.22.79-2.42,1.6-3.62,2.41q-.705-4.44-1.84-8.78c-.11-.41-.73-.22-.63.19a91.107,91.107,0,0,1,1.86,8.95c0,.02.01.03.01.05q-7.92,5.43-15.32,11.59c-.4-.86-.77-1.74-1.14-2.61-.75-1.77-1.45-3.57-2.12-5.37-.14-.39-.77-.21-.63.19q1.02,2.76,2.17,5.48c.38.9.78,1.8,1.18,2.7.01.02.01.04.02.06-1.32,1.11-2.64,2.22-3.94,3.37-1.96,1.73-3.88,3.5-5.78,5.3-.1-.19-.2-.39-.29-.56l-1.65-2.8a.33.33,0,0,0-.56.35c.59,1,1.17,1.99,1.76,2.99.09.15.17.31.26.48q-3.105,2.985-6.1,6.09c-.29.3.18.75.47.45,1.96-2.03,3.97-4.01,6.01-5.97a1.269,1.269,0,0,0,.1.12,3.563,3.563,0,0,0,1.15.58c2.07.87,3.99,1.95,5.98,3a.338.338,0,0,0,.33-.59,32.9,32.9,0,0,0-5.58-2.84,4.862,4.862,0,0,1-1.41-.63.7.7,0,0,1-.08-.1q4.7-4.47,9.65-8.64a.609.609,0,0,0,.15.12,7.093,7.093,0,0,0,1.31.28,29.519,29.519,0,0,1,5.41,1.85,40.874,40.874,0,0,1,4.86,2.77c.31.2.68-.3.39-.53a27.819,27.819,0,0,0-9.52-4.51c-.43-.12-.87-.23-1.3-.33a3.232,3.232,0,0,1-.67-.18c1.9-1.58,3.82-3.12,5.78-4.63,3.22-2.48,6.52-4.84,9.88-7.14a20.872,20.872,0,0,1,12.03,6.28c.29.3.71-.16.44-.46a20.748,20.748,0,0,0-11.68-6.36c4.7-3.18,9.52-6.18,14.47-8.96.64-.36,1.29-.71,1.94-1.06a31.768,31.768,0,0,1,3.09,1.4,35.31,35.31,0,0,1,3.15,1.97c.3.21.68-.3.39-.52a23.948,23.948,0,0,0-5.88-3.26q6.09-3.3,12.38-6.19C486.17,227.71,485.82,227.14,485.43,227.31Z",
    fill: "#096647"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M422.49,203.63a48.788,48.788,0,0,0-34.24-74.3c.37,13.29.75,26.7,4.01,39.59S401.93,194.3,422.49,203.63Z",
    fill: "#169c52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M422.83,203.03a91.733,91.733,0,0,0-1.75-16.97,29.582,29.582,0,0,1,2.76-4.74,27.885,27.885,0,0,1,4.05-4.29c.34-.3-.16-.76-.5-.48a24.413,24.413,0,0,0-6.56,8.29,92.207,92.207,0,0,0-3.43-12.12c-1.01-2.82-2.17-5.58-3.43-8.3a31.921,31.921,0,0,1,6.7-13.03c.3-.35-.22-.84-.52-.49a32.32,32.32,0,0,0-6.66,12.53,113.4,113.4,0,0,0-10.68-17.88c-.66-.9-1.34-1.79-2.02-2.68a16.241,16.241,0,0,1,1.18-3.59,17.156,17.156,0,0,1,2.12-3.21c.26-.32-.17-.75-.47-.45a13.606,13.606,0,0,0-3.37,6.54q-4.065-5.205-8.62-9.98c-.3-.31-.76.17-.46.48q4.545,4.77,8.61,9.97a32.51,32.51,0,0,0-7.31,1.9c-.39.15-.2.78.19.63a31.559,31.559,0,0,1,7.57-1.94,117.435,117.435,0,0,1,9.35,14.02c1.31,2.32,2.53,4.7,3.66,7.12a1.208,1.208,0,0,1-.05.18,44.108,44.108,0,0,0-15.29,2.28c-.4.13-.21.76.19.62a42.333,42.333,0,0,1,15.39-2.19.394.394,0,0,0,.14-.05,95.829,95.829,0,0,1,6.78,20.6c-.03.08-.07.15-.1.23a56.282,56.282,0,0,0-14.08.62c-.41.07-.22.69.19.62a49.624,49.624,0,0,1,14.03-.55c.04,0,.09-.01.13-.01a81.009,81.009,0,0,1,1.58,16.36A.342.342,0,0,0,422.83,203.03Z",
    fill: "#096647"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M425.5,255.73c3.9-15.16-2.93-31.72-14.46-42.31S384,197.49,368.52,195.15C372.74,222.52,392.92,246.82,425.5,255.73Z",
    fill: "#169c52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M425.89,255.59q-2.865-3.75-5.75-7.48a2.893,2.893,0,0,0,.08-.59q.12-1.305.3-2.61a74.993,74.993,0,0,1,1.94-9.4.365.365,0,0,0-.71-.17,55.924,55.924,0,0,0-1.85,8.57c-.1.71-.18,1.41-.26,2.12-.03.31-.06.62-.09.92-.01.11-.01.25-.01.39-3.81-4.91-7.66-9.79-11.62-14.57.32-5.36.59-10.87,2.91-15.81.2-.43-.45-.79-.65-.36-2.2,4.8-2.73,10.08-2.97,15.3-.16-.19-.31-.39-.47-.58-4.16-4.96-8.46-9.82-12.98-14.47a5.156,5.156,0,0,0,.33-2.3c.09-1.14.23-2.28.43-3.41a44.115,44.115,0,0,1,1.66-6.39c.15-.45-.55-.6-.71-.17a35.277,35.277,0,0,0-1.63,6.15c-.17.96-.31,1.93-.4,2.9q-.075.705-.12,1.41a3.663,3.663,0,0,1-.13,1.22q-3.72-3.81-7.64-7.41c-1.05-.96-2.11-1.9-3.19-2.84a1.483,1.483,0,0,0,.23-.65c.09-.59.18-1.19.27-1.78.18-1.19.35-2.38.54-3.57.08-.51-.71-.69-.77-.18-.14,1.04-.3,2.08-.46,3.13-.08.54-.16,1.07-.24,1.61a5.132,5.132,0,0,1-.12.8.458.458,0,0,1-.07.14c-3.07-2.63-6.23-5.15-9.49-7.53-.33-.24-.64.32-.31.56,3.14,2.28,6.17,4.7,9.12,7.22-1.99.44-3.99.87-5.98,1.3-.46.1-.25.8.21.7l3.5-.75,1.66-.36c.42-.09.9-.14,1.32-.27,3.77,3.27,7.39,6.72,10.89,10.3h-.01c-.85.23-1.78.29-2.64.47-.92.2-1.82.43-2.72.7a36.581,36.581,0,0,0-5.31,2.09c-.42.2-.04.82.38.62a34.884,34.884,0,0,1,5.76-2.2c.97-.27,1.95-.51,2.94-.7.54-.1,1.07-.18,1.61-.26a2.64,2.64,0,0,0,.57-.14c.52.54,1.05,1.07,1.57,1.61,4.29,4.51,8.37,9.22,12.34,14.01a48.21,48.21,0,0,0-11.31,4.62c-.39.22-.03.81.36.59a44.9,44.9,0,0,1,11.43-4.58c.01,0,.01-.01.02-.02,2.4,2.91,4.78,5.85,7.11,8.81,1.51,1.92,3.01,3.86,4.5,5.8a3.113,3.113,0,0,1-.84.23l-1.04.27-2.19.57c-.43.11-.23.77.2.66.77-.2,1.54-.39,2.31-.59a8.459,8.459,0,0,0,2-.55l.01-.01q2.775,3.615,5.54,7.23C425.55,256.35,426.18,255.97,425.89,255.59Z",
    fill: "#096647"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 8.06,
    cy: 8.06,
    r: 8.06,
    transform: "translate(482.38 282.58)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 8.06,
    cy: 8.06,
    r: 8.06,
    transform: "translate(376.67 296.83)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 8.06,
    cy: 8.06,
    r: 8.06,
    transform: "translate(348.92 208.95)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 6.2,
    cy: 6.2,
    r: 6.2,
    transform: "translate(490.43 235.66)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 6.2,
    cy: 6.2,
    r: 6.2,
    transform: "translate(496.63 185.59)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 6.2,
    cy: 6.2,
    r: 6.2,
    transform: "translate(437.52 137.57)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(449.91 290.64)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(360.07 279.48)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(381.63 179.39)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_10",
    "data-name": "Elipse 10",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(356.98 142.29)",
    fill: "#8fe3dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(473.66 134.48)",
    fill: "#8fe3dc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8",
    "data-name": "Ret\\xE2ngulo 8",
    width: 203.11,
    height: 16.6,
    transform: "translate(324.29 100.83)",
    fill: "#28619e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9",
    "data-name": "Ret\\xE2ngulo 9",
    width: 29.29,
    height: 16.6,
    transform: "translate(490.29 100.83)",
    fill: "#0e3a7d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_10",
    "data-name": "Ret\\xE2ngulo 10",
    width: 7.81,
    height: 16.6,
    transform: "translate(475.64 100.83)",
    fill: "#0e3a7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_11",
    "data-name": "Ret\\xE2ngulo 11",
    width: 3.91,
    height: 16.6,
    transform: "translate(386.27 100.83)",
    fill: "#599ec9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_12",
    "data-name": "Ret\\xE2ngulo 12",
    width: 44.92,
    height: 16.6,
    transform: "translate(334.06 100.83)",
    fill: "#599ec9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 203.11,
    height: 16.6,
    transform: "translate(324.29 320.61)",
    fill: "#28619e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 29.29,
    height: 16.6,
    transform: "translate(490.29 320.61)",
    fill: "#0e3a7d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15",
    "data-name": "Ret\\xE2ngulo 15",
    width: 7.81,
    height: 16.6,
    transform: "translate(475.64 320.61)",
    fill: "#0e3a7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16",
    "data-name": "Ret\\xE2ngulo 16",
    width: 3.91,
    height: 16.6,
    transform: "translate(386.27 320.61)",
    fill: "#599ec9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17",
    "data-name": "Ret\\xE2ngulo 17",
    width: 44.92,
    height: 16.6,
    transform: "translate(334.06 320.61)",
    fill: "#599ec9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M548.35,335.1H303.34l-8.02,15.44H556.37Z",
    fill: "#09235e"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_18",
    "data-name": "Ret\\xE2ngulo 18",
    width: 261.05,
    height: 76.34,
    transform: "translate(295.32 350.54)",
    fill: "#354d6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 112.64,
    height: 62.65,
    transform: "translate(438.19 355.06)",
    fill: "#213254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_20",
    "data-name": "Ret\\xE2ngulo 20",
    width: 112.64,
    height: 59.56,
    transform: "translate(442.73 355.06)",
    fill: "#4d6880"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 99,
    height: 62.65,
    transform: "translate(326.84 355.06)",
    fill: "#213254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22",
    "data-name": "Ret\\xE2ngulo 22",
    width: 95.17,
    height: 59.56,
    transform: "translate(330.68 355.06)",
    fill: "#4d6880"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_23",
    "data-name": "Ret\\xE2ngulo 23",
    width: 18.55,
    height: 6.84,
    transform: "translate(213.5 425.04)",
    fill: "#132554"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_24",
    "data-name": "Ret\\xE2ngulo 24",
    width: 18.55,
    height: 6.84,
    transform: "translate(114.38 425.04)",
    fill: "#132554"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_25",
    "data-name": "Ret\\xE2ngulo 25",
    width: 18.55,
    height: 6.84,
    transform: "translate(312.61 425.04)",
    fill: "#132554"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_26",
    "data-name": "Ret\\xE2ngulo 26",
    width: 223.61,
    height: 90.81,
    transform: "translate(110.29 337.13)",
    fill: "#e3faf8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_27",
    "data-name": "Ret\\xE2ngulo 27",
    width: 223.61,
    height: 6.84,
    transform: "translate(110.29 335.03)",
    fill: "#bee6e4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_28",
    "data-name": "Ret\\xE2ngulo 28",
    width: 1.95,
    height: 86.07,
    transform: "translate(194 341.86)",
    fill: "#bee6e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_29",
    "data-name": "Ret\\xE2ngulo 29",
    width: 70.31,
    height: 22.46,
    transform: "translate(118.59 344.51)",
    fill: "#8fc7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_30",
    "data-name": "Ret\\xE2ngulo 30",
    width: 19.53,
    height: 2.93,
    transform: "translate(143.98 347.43)",
    fill: "#b02e27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_31",
    "data-name": "Ret\\xE2ngulo 31",
    width: 70.31,
    height: 22.46,
    transform: "translate(118.59 371.79)",
    fill: "#8fc7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_32",
    "data-name": "Ret\\xE2ngulo 32",
    width: 19.53,
    height: 2.93,
    transform: "translate(143.98 374.71)",
    fill: "#b02e27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_33",
    "data-name": "Ret\\xE2ngulo 33",
    width: 70.31,
    height: 22.46,
    transform: "translate(118.59 399.07)",
    fill: "#8fc7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_34",
    "data-name": "Ret\\xE2ngulo 34",
    width: 19.53,
    height: 2.93,
    transform: "translate(143.98 401.99)",
    fill: "#b02e27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    width: 60.54,
    height: 77.02,
    transform: "translate(201.07 344.51)",
    fill: "#8fc7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_36",
    "data-name": "Ret\\xE2ngulo 36",
    width: 2.93,
    height: 44.92,
    transform: "translate(254.28 360.074)",
    fill: "#b02e27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_37",
    "data-name": "Ret\\xE2ngulo 37",
    width: 60.54,
    height: 77.02,
    transform: "translate(265.29 344.51)",
    fill: "#8fc7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 2.93,
    height: 44.92,
    transform: "translate(269.687 360.07)",
    fill: "#b02e27"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 230.45,
    height: 10.74,
    transform: "translate(107.55 326.73)",
    fill: "#28619e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_40",
    "data-name": "Ret\\xE2ngulo 40",
    width: 230.45,
    height: 7.81,
    transform: "translate(107.55 329.66)",
    fill: "#132554"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_41",
    "data-name": "Ret\\xE2ngulo 41",
    width: 51.19,
    height: 4.56,
    transform: "translate(153.63 322.17)",
    fill: "#2a2c33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_42",
    "data-name": "Ret\\xE2ngulo 42",
    width: 26.26,
    height: 11.84,
    transform: "translate(166.09 310.34)",
    fill: "#17181f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M127.23,310.98v-58.7a3.952,3.952,0,0,1,3.95-3.95h96.08a3.952,3.952,0,0,1,3.95,3.95v58.7a3.952,3.952,0,0,1-3.95,3.95H131.18A3.939,3.939,0,0,1,127.23,310.98Z",
    fill: "#2a2c33"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 2.14,
    cy: 2.14,
    r: 2.14,
    transform: "translate(177.08 309.25)",
    fill: "#474c57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M226.78,253.67v52.7a.841.841,0,0,1-.85.84H132.77a.841.841,0,0,1-.85-.84v-52.7a.849.849,0,0,1,.85-.85h93.16A.849.849,0,0,1,226.78,253.67Z",
    fill: "#4bb4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M226.78,253.67v5.76H131.91v-5.76a.849.849,0,0,1,.85-.85h93.16A.851.851,0,0,1,226.78,253.67Z",
    fill: "#1c62a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 1.51,
    cy: 1.51,
    r: 1.51,
    transform: "translate(219.2 254.61)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 1.51,
    cy: 1.51,
    r: 1.51,
    transform: "translate(213.46 254.61)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 1.51,
    cy: 1.51,
    r: 1.51,
    transform: "translate(207.44 254.61)",
    fill: "#3aa1c7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_43",
    "data-name": "Ret\\xE2ngulo 43",
    width: 33.69,
    height: 44.43,
    transform: "translate(191.8 261.33)",
    fill: "#1c62a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_44",
    "data-name": "Ret\\xE2ngulo 44",
    width: 23.68,
    height: 1.46,
    transform: "translate(198.8 264.03)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_45",
    "data-name": "Ret\\xE2ngulo 45",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 269.89)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_46",
    "data-name": "Ret\\xE2ngulo 46",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 275.75)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_47",
    "data-name": "Ret\\xE2ngulo 47",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 282.21)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_48",
    "data-name": "Ret\\xE2ngulo 48",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 288.36)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_49",
    "data-name": "Ret\\xE2ngulo 49",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 294.51)",
    fill: "#3aa1c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_50",
    "data-name": "Ret\\xE2ngulo 50",
    width: 28.32,
    height: 1.46,
    transform: "translate(194.15 300.37)",
    fill: "#3aa1c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 16.98,
    cy: 16.98,
    r: 16.98,
    transform: "translate(142.25 266.56)",
    fill: "#b9e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 15.14,
    cy: 15.14,
    r: 15.14,
    transform: "translate(144.09 268.4)",
    fill: "#278a49"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 66.66,
    cy: 66.66,
    r: 66.66,
    transform: "translate(141.26 83.58)",
    fill: "#e1fcf7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 61.78,
    cy: 61.78,
    r: 61.78,
    transform: "translate(146.14 88.46)",
    fill: "#278a49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M209.95,88.11c-.15,21.04-4.16,41.84-6.53,62.75s-3.06,42.5,3.25,62.57",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M204.49,145.38c19.05-11.03,44.4-6.74,62.83-18.78",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M205.8,128.65a42.169,42.169,0,0,0-24.65-15.58c-7.5-1.57-15.85-1.24-22.01-5.81",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M203.32,191.89c8.14-3.39,17.43-1.72,26.01.35s17.51,4.49,26.09,2.43",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M200.64,178.24a143.629,143.629,0,0,1-56.28-14.83",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M187.92,115.55c-6.89,2.69-10.19,11.39-14.88,17.12-7.01,8.55-18.7,11.32-29.52,13.58",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M175.83,129.42c-4.61.17-8.93-2.02-13.2-3.78s-9.15-3.13-13.41-1.36",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M165.09,126.63a43.58,43.58,0,0,1-18.72,12.91",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M160.56,124.61a33.2,33.2,0,0,1,8.08-12.87",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M193.45,117.48a34.359,34.359,0,0,0-3.87-26.43",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M194.1,104.29a65.276,65.276,0,0,1,14.84-4.06",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M193.98,111.77,176.61,99.5c-1.38-.98-3.22-1.97-4.64-1.06",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M183.27,104.34a15.865,15.865,0,0,0-8.26,7.81",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M200.94,101.82a122.549,122.549,0,0,0-1.01-15.9c-.07.27-.14.55-.21.82",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M194.86,107.66c3.61,1.7,10.16,4.87,13.77,6.57",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M198.75,121.92c-9.35,9.99-10.67,25.23-18.75,36.26-3.96,5.41-9.37,9.56-14.7,13.63",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M189.18,138.29c1.78,3.37,4.56,6.09,6.94,9.07s4.43,6.52,4.32,10.33",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M183.68,152.44a43.794,43.794,0,0,1,3.56,22.53",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M187.13,145.13a56.637,56.637,0,0,0-40.54,17.21",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M180.21,121.39a35.643,35.643,0,0,1-3.85,24.2",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M160.41,142.43c-.5,3.07-1,6.15-1.5,9.22",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M220.27,139.82c3.18-7.62,6.37-15.8,7.1-24.14.43-4.98-.89-9.55-.71-14.46.1-2.79.75-8.71,3.46-10.12",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M237.27,136.49l21.35-24.83",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M249.81,122.24a80.682,80.682,0,0,0-21.88-11.75",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M236.03,113.17a29.068,29.068,0,0,1,7.7-14.56",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M225.63,123.75c-3.11-6.23-10.98-11.26-17.71-13.05",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M209.18,104.89c6.14-2.54,14.45-8.34,18.24-13.79",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M218.4,115.28c-2.9,7.55-3.69,16.46-3.89,24.54",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M246.06,125.99a58.968,58.968,0,0,1,11.23,5.2",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M217.85,140.8c5.6,7.5,11.25,15.1,14.74,23.79s4.6,18.71.98,27.34",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M248.38,134.79c3.61,6.36,4.66,13.79,6.53,20.86s5.02,14.36,11.24,18.2",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M253.32,148.54a67.124,67.124,0,0,1-22.93,9.23",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M236.08,177.79c4.55.61,9.11-1.05,13.14-3.26s7.73-5,11.89-6.94",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M233.61,167.36a89.462,89.462,0,0,0-32.05,10.09",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M216.86,170.48a86.582,86.582,0,0,0-6.15-27.3",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M203.96,163.44q6.24-1.155,12.47-2.3",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M223.22,168.61a49.907,49.907,0,0,1,.72,21.31",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M236.14,136.21a70.129,70.129,0,0,0,3.82,18.28",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M252.13,144.1q8.625-3.18,17.24-6.35",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M256.36,142.5q5.085,6.21,10.16,12.43c1.23,1.5,2.6,3.1,4.49,3.55",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M248.13,175.58a78.061,78.061,0,0,1-1.54,19.29",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M247.23,152.47l6.27,19.62",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M235.97,156.02c.71,5.51,1.35,9.48,4.69,13.92a12.889,12.889,0,0,1,2.5,4.83c.2.85-.03,1.76.29,2.42",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M206.45,200.35c3.25,1.06,6.74,1.06,10.15,1.31s6.95.83,9.73,2.83a31.31,31.31,0,0,0,3.36,2.52,3.658,3.658,0,0,0,3.96-.04",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M215.85,190.42q.78,5.61,1.55,11.22",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M229.25,192.95q-1.335,5.9-2.66,11.8",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M212,201.23a35.135,35.135,0,0,0,1.06,6.85,12.045,12.045,0,0,0,3.53,5.86",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M238.13,194.76a23.388,23.388,0,0,0,1.72,11.09",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M192.2,177.93c-4.99,9.28-6.96,19.84-8.85,30.2",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M175.96,173.57c-4.66,8.18-3.3,18.39-5.81,27.47",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M158.4,169.35a36.212,36.212,0,0,1-4.65,10.71",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M172.49,184.5a92.959,92.959,0,0,1-16.31-8.51",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M171.49,191.74a20.515,20.515,0,0,0,13.74,8.84",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M187.39,189.81c4.47,3.26,11,2.68,15.27,6.2",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M203.06,208.03a61.372,61.372,0,0,0-19.13-3.4",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M189.67,184.06a35.407,35.407,0,0,1-14.93-6.7",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M172.36,187.71a73.206,73.206,0,0,0-14.71.94",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M240.17,115.52a66.315,66.315,0,0,1-8.78,21.7",
    fill: "none",
    stroke: "#9bc74a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M191.65,214.61q-1.665,12.825-3.32,25.65a218.991,218.991,0,0,1,14.26-26.14C198.93,214.39,195.26,214.65,191.65,214.61Z",
    fill: "#e1fcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M276.52,427.38s1.98,9.9,1.18,10.94c-1.07,1.4-27.77,1.14-27.99-1.04-.34-3.38,5.83-7.9,12.73-9.19A61.659,61.659,0,0,1,276.52,427.38Z",
    fill: "#132554"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M283.38,346.43q-.5,6.885-1.01,13.77-1.56,21.45-3.13,42.9l-2.04,27.84a65.859,65.859,0,0,1-17.75-2.02c-.14-10.02-.08-20.02.12-30.02.25-12.94.73-25.89,1.32-38.87q.54-12.06,1.17-24.16C269.32,340.41,276.35,343.42,283.38,346.43Z",
    fill: "#28619e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M282.37,360.2q-1.56,21.45-3.13,42.9a78.442,78.442,0,0,1-19.68-4.2c.25-12.94.73-25.89,1.32-38.87C268.05,360.08,275.2,360.14,282.37,360.2Z",
    fill: "#1b498f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M286.67,427.38s-1.98,9.9-1.18,10.94c1.07,1.4,27.77,1.14,27.99-1.04.34-3.38-5.83-7.9-12.73-9.19A61.659,61.659,0,0,0,286.67,427.38Z",
    fill: "#132554"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M307.55,337.72c-.19,7.7-.41,15.23-.69,22.68-.51,13.69-1.17,27.08-2.07,40.63-.61,9.02-1.31,18.11-2.14,27.41-2.84.95-13.71,2.23-16.59,1.47.02-8.97-.04-17.79-.13-26.56-.14-14.38-.34-28.62-.42-43.13-.02-4.49-.03-9-.02-13.56C292.73,344.19,299.96,341.71,307.55,337.72Z",
    fill: "#28619e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M306.86,360.4c-.51,13.69-1.17,27.08-2.07,40.63a78.234,78.234,0,0,1-18.86,2.32c-.14-14.38-.34-28.62-.42-43.13Z",
    fill: "#1b498f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M291.8,247.2l.57,11.07-16.41.65,1.41-11.88Z",
    fill: "#f2c9aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M297.84,226.08a26.2,26.2,0,0,0,.16,8.47,26.488,26.488,0,0,1,.17,8.47c-.56,2.78-2.2,5.51-4.82,6.61-3.76,1.59-8-.56-12.08-.54a19.531,19.531,0,0,1,2.96-15.2A18.208,18.208,0,0,1,297.84,226.08Z",
    fill: "#f2c9aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M300.81,228.34a3.963,3.963,0,0,1-4.25,2.88,31.679,31.679,0,0,1-3.94,8.42,11.107,11.107,0,0,1-7.68,10.98,4.083,4.083,0,0,1-2.96-.02,1.882,1.882,0,0,1-.93-2.51,6.984,6.984,0,0,1-5.18,2.51,4.44,4.44,0,0,1-2.57-.66,1.521,1.521,0,0,1-.59-2.26c-3.07-2.43-6.04-5.2-7.64-8.77s-1.54-8.13,1.06-11.06c-1.74.45-2.79.53-3.4.04a2.111,2.111,0,0,1-.58-2.13,4.332,4.332,0,0,1,1.23-1.95c1.4-1.45,3.71-2.48,5.39-1.37a11.17,11.17,0,0,1,.72-4.17,14.769,14.769,0,0,1,9.49-8.65c5.66-1.66,11.89-.09,16.92,3,1.32.8,2.67,1.85,3,3.37s-1.1,3.35-2.56,2.82c2.01,1.93,4.13,4.03,4.69,6.76A5.165,5.165,0,0,1,300.81,228.34Z",
    fill: "#854301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M300.81,228.34a13,13,0,0,0-8.3-10.26c1.18-.21,1.66-1.8,1.15-2.88a4.925,4.925,0,0,0-2.75-2.17c-7.27-3-16.29-.66-21.43,5.22a14.769,14.769,0,0,1,9.49-8.65c5.66-1.66,11.89-.09,16.92,3,1.32.8,2.67,1.85,3,3.37s-1.1,3.35-2.56,2.82c2.01,1.93,4.13,4.03,4.69,6.76A5.122,5.122,0,0,1,300.81,228.34Z",
    fill: "#b5630b"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_21",
    "data-name": "Elipse 21",
    cx: 2.8,
    cy: 3.43,
    rx: 2.8,
    ry: 3.43,
    transform: "translate(289.95 235.43)",
    fill: "#f2c9aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M292.57,272.23l8.03-14.4s9.19,2.63,11.78,7.54,12.93,50.19,10.75,54.22-21.19,9.95-21.19,9.95Z",
    fill: "#d3e4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M315.94,390.91c-4.34,5.19-53.91,7.06-61.23,1-1.49-1.23-1.63-11.61-1.04-26.03,1.56-38.49,13.66-106.22,13.66-106.22a32.514,32.514,0,0,1,15.15-3.59c9.01,0,20.7,1.7,22.68,3.73,1.21,1.24,6.01,48.7,8.92,86.18C315.92,369.82,317.02,389.62,315.94,390.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M315.94,390.91c-4.34,5.19-53.91,7.06-61.23,1-1.49-1.23-1.63-11.61-1.04-26.03,12.17,1.48,24.56.8,36.08-3.29a57.311,57.311,0,0,0,24.32-16.61C315.92,369.82,317.02,389.62,315.94,390.91Z",
    fill: "#e4f3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M237.63,322.91c-3.37-.1-6.73-.19-10.1-.27a13.569,13.569,0,0,1-2.08.6,11.31,11.31,0,0,1-10.73-3.66,21.606,21.606,0,0,0-2.98,1.26,11.632,11.632,0,0,0,.62,3.87c.13.52.18,1.17-.21,1.47-.42.32-.98-.02-1.39-.36a8.368,8.368,0,0,1-2.52-3.07,3.609,3.609,0,0,1,.51-3.86,4,4,0,0,1,1.88-4.69,1.593,1.593,0,0,1-.27-1.77,3.819,3.819,0,0,1,1.04-1.34c2.1-1.95,5.22-4.51,7.35-3.83,1.69.54,4.4,3.23,7.09,5.18a16.618,16.618,0,0,0,1.94,1.25,20.12,20.12,0,0,0,8.61-2.59C236.59,315.04,237.11,318.98,237.63,322.91Z",
    fill: "#f2c9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M237.63,322.91c-3.37-.1-6.73-.19-10.1-.27a13.569,13.569,0,0,1-2.08.6,54.819,54.819,0,0,1,.4-10.79,16.626,16.626,0,0,0,1.94,1.25,20.121,20.121,0,0,0,8.61-2.59C236.59,315.04,237.11,318.98,237.63,322.91Z",
    fill: "#de8071"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M271.29,277.8c.27-6.94,4.87-20.69.09-19.97-4.16.63-10.55,4.06-13.53,12.52-4.31,12.26-5.99,28.3-10.47,34.38-1.84,2.5-20.81,7.12-20.81,7.12l2.03,15.37s30.68-1.1,33.34-5.91S270.83,289.71,271.29,277.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M274.73,281.63c.48,13.62-4.99,35.16-7.03,37.44-1.41,1.58-6.04,3.92-8.63,4.55",
    fill: "none",
    stroke: "#d3e4eb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_107",
    "data-name": "Grupo 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_51",
    "data-name": "Ret\\xE2ngulo 51",
    width: 36.51,
    height: 126,
    transform: "translate(585.22 195.11)",
    fill: "#69b5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M627.36,203.9H579.58a7.639,7.639,0,0,1-7.64-7.64v-2.3a7.639,7.639,0,0,1,7.64-7.64h47.78a7.639,7.639,0,0,1,7.64,7.64v2.3A7.639,7.639,0,0,1,627.36,203.9Z",
    fill: "#69b5db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M601.08,264.75,533.7,395.17a21.906,21.906,0,0,0,19.46,31.96H653.79a21.9,21.9,0,0,0,19.46-31.96L605.87,264.75A2.7,2.7,0,0,0,601.08,264.75Z",
    fill: "#69b5db"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_52",
    "data-name": "Ret\\xE2ngulo 52",
    width: 29.34,
    height: 126,
    transform: "translate(588.67 195.11)",
    fill: "#dff4f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M620.15,203.9H585.37a7.639,7.639,0,0,1-7.64-7.64v-2.3a7.639,7.639,0,0,1,7.64-7.64h34.78a7.639,7.639,0,0,1,7.64,7.64v2.3A7.652,7.652,0,0,1,620.15,203.9Z",
    fill: "#dff4f1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M601.06,273.7,542.19,390.49a21.908,21.908,0,0,0,19.56,31.77h83.44a21.9,21.9,0,0,0,19.56-31.77L605.88,273.7A2.7,2.7,0,0,0,601.06,273.7Z",
    fill: "#dff4f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M635.51,414.4H571.44c-14.07,0-23.12-17.66-16.72-32.58l6.34-14.59h84.83l6.34,14.59C658.63,396.74,649.58,414.4,635.51,414.4Z",
    fill: "#66ab20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 9.34,
    cy: 9.34,
    r: 9.34,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 570.565, 398.533)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    cx: 9.34,
    cy: 9.34,
    r: 9.34,
    transform: "translate(614.89 342.5)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    cx: 7.41,
    cy: 7.41,
    r: 7.41,
    transform: "translate(616.82 394.12)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_25",
    "data-name": "Elipse 25",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(605.88 377.83)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(586.99 338.86)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(609.52 335.22)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_28",
    "data-name": "Elipse 28",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(594.97 277.69)",
    fill: "#96bf3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_29",
    "data-name": "Elipse 29",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(602.25 300.13)",
    fill: "#96bf3d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonagens);
export default __webpack_public_path__ + "static/media/Personagens.b70aff1147059f029944f25d915941ba.svg";
export { ForwardRef as ReactComponent };